import styled from '@emotion/styled';
import FormHelperText from '@mui/material/FormHelperText';

export const StyledAdditionalNotes = styled<any>(FormHelperText)`
  display: flex;
  font-size: ${(props) => props.fontSize || '1rem'};
  font-weight: ${(props) => props.fontWeight || 'normal'};
  font-style: ${(props) => props.fontStyle || 'normal'};
  padding: ${(props) => props.padding || '0'};
  color: ${(props) => props.theme.colors?.gray[900]};
  line-height: 1.5rem;
  margin-top: 0.5rem;
  margin-bottom: 0.125rem;
  margin-left: unset;
  &&.Mui-error.Mui-additional-notes {
    color: ${(props) => props.theme.colors?.gray[900]};
  }
`;
